exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".Form_form_1-4r0{width:100%;height:100%;margin:auto}@media (min-width:760px){.Form_form_1-4r0{height:auto}}.Form_file_zPHAY{margin-top:10px;padding:5px 15px;border-radius:5px;background-color:#000;color:#fff}@media (max-width:768px){.Form_file_zPHAY{position:absolute;left:50%;top:50%;-webkit-transform:translate(-50%,-50%);transform:translate(-50%,-50%)}}@media (min-width:768px){.Form_file_zPHAY{position:relative;display:inline-block;cursor:pointer;-webkit-transform:none;transform:none}}@media (max-width:768px){.Form_fileHasImage_1y5v_{display:none}}.Form_input_BXCIQ{position:absolute;top:0;bottom:0;left:0;right:0;z-index:10;opacity:0}", ""]);

// exports
exports.locals = {
	"form": "Form_form_1-4r0",
	"file": "Form_file_zPHAY",
	"fileHasImage": "Form_fileHasImage_1y5v_",
	"input": "Form_input_BXCIQ"
};